import { encryptSessionStore, getSession, type ISession } from '../actions/session.actions';

export default async function amendSessionStore(updateFn: (session: ISession) => ISession) {
  const session = await getSession();
  const newData = updateFn(session ?? { globalResolvedConditions: [], perCampaignSessionData: {} });

  await encryptSessionStore(newData);
}
